const d = document, c = console.log, $ = jQuery;
export class UI {

    constructor(){
        this.init();
    }

    init(){
        // this.submenu();
        this.headerScrolling(100);
        this.bgColorEREN();
        this.bgColorButtonSlider();
        this.paramTID();
        this.menuResponsive();
        this.placeholderInputFormHeader();
        this.applyButtonText();
        this.selectElencosNacionalesText();
        this.shareRRSS();
    }

    bgColorEREN(){
      const items = d.querySelectorAll('.listElencos .__layer, .eventosCard .buttonAction');
      if (items.length > 0) {
        items.forEach(item => {
          item.style.backgroundColor = item.getAttribute('data-color');
        });
      }
    }

    bgColorButtonSlider(){
      const items = d.querySelectorAll('.itemSliderHome');
      if (items.length > 0) {
        items.forEach(item => {
          const button = item.querySelector('.buttonAction');
          if (button) {
            button.style.backgroundColor = item.getAttribute('data-color');
          }
        });
      }
    }

    headerScrolling(limit = 500){
        const logoSubmenu = d.querySelector('.menuElencoLogo');
        const header = d.querySelector('.header');
        if (header) {
            let prevScrollpos = window.scrollY;
            window.addEventListener('scroll', () =>{
                if (prevScrollpos < window.scrollY && window.scrollY > limit) {
                    header.classList.add('__hide');
                } else {
                    header.classList.remove('__hide');
                }
                if (window.scrollY > limit) {
                    logoSubmenu ? logoSubmenu.classList.add('__hide') : null;
                } else {
                    logoSubmenu ? logoSubmenu.classList.remove('__hide') : null;
                }
                prevScrollpos = window.scrollY;
            });
        }
    }

    submenu(){
        const header = d.querySelector('header.header');
        const menu = d.querySelector('.menu');
        const submenu = d.querySelector('.submenu');
        if (menu && submenu) {
            const hasSubmenuItems = menu.querySelectorAll('.menuList li');
            const submenus = submenu.querySelectorAll('ul');
            if (hasSubmenuItems.length > 0 && submenus.length > 0) {
                hasSubmenuItems.forEach(item => {
                    item.addEventListener('mouseover', e => {
                        if (item.classList.contains('hasSubmenu')) {
                            const elenco = item.getAttribute('data-elencos');
                            const subItemToShow = submenu.querySelector(`ul[data-elencos="${elenco}"]`);
                            if (subItemToShow) {
                                submenus.forEach(el => el.classList.remove('__active'));
                                submenu.classList.add('__active');
                                subItemToShow.classList.add('__active');
                            }
                        } else
                            submenu.classList.remove('__active');
                    });
                });
                header.addEventListener('mouseleave', () => {
                    submenu.classList.remove('__active');
                });
            }
        }
    }

    placeholderInputFormHeader(){
      const inputSearch = d.querySelector('.headerSearch form input[type="search"]');
      if (inputSearch) {
        inputSearch.setAttribute('placeholder', 'Buscar');
      }
    }

    menuResponsive(){
      const menuResponsive = d.querySelector('#block-system-menu-block-menu-responsive');
      if (menuResponsive) {
        const hasSubmenuDropdown = menuResponsive.querySelectorAll('.hasSubmenuDropdown');
        if (hasSubmenuDropdown.length > 0) {
          hasSubmenuDropdown.forEach(dropdown => {
            dropdown.addEventListener('click', e => {
              e.preventDefault();
              const ulInteractive = dropdown.parentElement.nextElementSibling;
              if (ulInteractive) {
                $(dropdown).toggleClass('active');
                $(ulInteractive).slideToggle();
              }
            });
          });
        }
      }
    }

    selectElencosNacionalesText(){
      const select = d.querySelector('.eventosCalendarioHeader form select option:nth-child(1)');
      if (select) {
        select.textContent = '- Todos los Elencos Nacionales -';
      }
    }

    applyButtonText(){
      const applyButtonText = d.querySelectorAll('.views-exposed-form input.form-submit');
      if (applyButtonText.length) {
        applyButtonText.forEach(button => {
          let text = button.getAttribute('value');
          if (text == 'Apply') {
            button.setAttribute('value', 'Aplicar');
          }
        });
      }
    }

    getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1),
          sURLVariables = sPageURL.split('&'),
          sParameterName,
          i;

      for (i = 0; i < sURLVariables.length; i++) {
          sParameterName = sURLVariables[i].split('=');

          if (sParameterName[0] === sParam) {
              return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
          }
      }
      return false;
    };

    paramTID(){
      const calendarEntry = d.querySelectorAll('.eventosCalendarioList a.__active');
      if (calendarEntry.length > 0) {
        calendarEntry.forEach(entry => {
          const paramTID = this.getUrlParameter('tid') ? this.getUrlParameter('tid') : 'All';
          const entryURL = entry.getAttribute('href');
          if (entryURL) {
            entry.setAttribute('href', `${entryURL}?tid=${paramTID}`);
          }
        });
      }
    }

    shareRRSS(){
      const linksShare = document.querySelectorAll('.shareList .__share');
      if (linksShare.length > 0) {
          linksShare.forEach(link => {
              link.addEventListener('click', e => {
                  e.preventDefault();
                  window.open(link.getAttribute('href'),'', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
              });
          });
      }
      const copyLinks =document.querySelectorAll('.shareList .__copy');
      if (copyLinks.length > 0) {
          copyLinks.forEach(copyLink => {
              copyLink.addEventListener('click', (event) => {
                  event.preventDefault();
                  const text = copyLink.parentElement.parentElement.parentElement.querySelector('.shareCopyText');
                  if (text) {
                      text.select();
                      document.execCommand("copy");
                      alert('Enlace copiado!');
                  }
              });
          });
      }
  }
}
